import './inputs.css'

// The "title + control" vertical block used throughout modals and forms.
// Renders an optional label (with required marker), the control, and an
// optional hint or error message.
function Field({ label, required, hint, error, children }) {
  return (
    <div className="ct-field">
      {label && (
        <span className="ct-field-label">
          {label}
          {required && <span className="ct-field-req">*</span>}
        </span>
      )}
      {children}
      {error ? (
        <span className="ct-field-error">{error}</span>
      ) : (
        hint && <span className="ct-field-hint">{hint}</span>
      )}
    </div>
  )
}

export default Field
